/**
 * Check all the hooks provided are ready (not loading and with data)
 * @param   {Array<Object>} hooks
 * @returns {boolean}
 */
export const checkHooksAreReady = hooks => hooks
  .every(hook => hook && !hook.loading && hook.data);
